import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, API_BASE, getToken, type Entity } from "../api";
import FileDrop from "../components/FileDrop";

export default function NewDocument() {
  const nav = useNavigate();
  const [entities, setEntities] = useState<Entity[]>([]);
  const [entityId, setEntityId] = useState("");
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [file, setFile] = useState<File | null>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api<{ entities: Entity[] }>("/entities").then((r) => {
      setEntities(r.entities);
      if (r.entities[0]) setEntityId(r.entities[0].id);
    });
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const r = await api<{ id: string }>("/documents", {
        method: "POST",
        json: { entity_id: entityId, title: title.trim(), description: desc.trim() || null },
      });
      if (file) {
        const buf = await file.arrayBuffer();
        const res = await fetch(`${API_BASE}/documents/${r.id}/file`, {
          method: "PUT",
          headers: {
            "Content-Type": file.type || "application/octet-stream",
            Authorization: `Bearer ${getToken()}`,
          },
          body: buf,
        });
        if (!res.ok) throw new Error("Échec téléversement");
      }
      nav(`/documents/${r.id}`);
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : "Erreur");
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <h2>Nouveau document</h2>
      <form onSubmit={submit}>
        <label className="section-h" style={{ display: "block" }}>Entité</label>
        <select value={entityId} onChange={(e) => setEntityId(e.target.value)} required>
          {entities.map((e) => (<option key={e.id} value={e.id}>{e.name}</option>))}
        </select>

        <label className="section-h" style={{ display: "block", marginTop: 14 }}>Titre</label>
        <input value={title} onChange={(e) => setTitle(e.target.value)} required maxLength={200} />

        <label className="section-h" style={{ display: "block", marginTop: 14 }}>Description</label>
        <textarea value={desc} onChange={(e) => setDesc(e.target.value)} rows={3} />

        <label className="section-h" style={{ display: "block", marginTop: 14 }}>
          Pièce jointe (PDF, image…)
        </label>
        <FileDrop
          accept="application/pdf,image/*"
          onPick={setFile}
          hint="Glisse-dépose un PDF ou une image, ou clique pour parcourir"
        />

        {err ? <div className="error" style={{ marginTop: 10 }}>{err}</div> : null}

        <div style={{ height: 18 }} />
        <button className="btn btn-primary full" type="submit" disabled={busy || !entityId || !title}>
          {busy ? "Création…" : "Créer le document"}
        </button>
      </form>
    </>
  );
}
